module.exports = __webpack_public_path__ + "img/7.da58e030.svg";